// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"631":"ba8139fefa364009","888":"3d87fa31c160a948"}[chunkId] + ".css";
};